import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { FileOrLink, IAttachmentTypeListItem } from "models/attachments"
import React from "react";

type AttachmentFormatSelectionProps = {
    disabled?: boolean;
    value: FileOrLink;
    onChanged: (value: FileOrLink) => void;
    islinkRequired: boolean | undefined;
};

const AttachmentFormatSelection: React.FC<AttachmentFormatSelectionProps> = (props) => {
    const {
        disabled,
        value,
        onChanged,
        islinkRequired
    } = props;

    //--------------------------------------- HANDLERS ---------------------------------------//
    const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let rbValue = event.target.value;

        if (rbValue == FileOrLink.File.toString()) {
            onChanged(FileOrLink.File);
        }
        else {
            onChanged(rbValue === FileOrLink.Link.toString()
                ? FileOrLink.Link
                : FileOrLink.SFTP);
        }
    };
    return (
        <FormControl disabled={disabled || islinkRequired}>
            <FormLabel id="attachment-radio-buttons-group-label">Attachment Format (required):</FormLabel>
            <RadioGroup
                aria-labelledby="attachment-radio-buttons-group-label"
                defaultValue={FileOrLink.File}
                value={value}
                name="radio-buttons-group"
                onChange={handleFormatChange}
                row
            >
                <FormControlLabel value={FileOrLink.File} control={<Radio  />} label="File" />
                <FormControlLabel value={FileOrLink.Link} control={<Radio />} label="Link" />
                <FormControlLabel value={FileOrLink.SFTP} control={<Radio />} label="Large File/SFTP" />
            </RadioGroup>
        </FormControl>
    );
};

export default AttachmentFormatSelection;